(function () {
    'use strict';

    function workflowProcessingService($interval, $window, $log, fileUploadsService, notifyService) {
        var adminMode = false;
        var mode = "";

        function uploadFiles() {
            for (var i = 0; i < fileUploadsService.uploaders.length; i++) {
                fileUploadsService.uploaders[i].uploadStoredFiles();
            }
        };

        function getNextPhaseSummary(phases, currentPhaseIndex) {
            return (currentPhaseIndex < phases.length)
                ? {
                    NextPhaseIndex: parseInt(currentPhaseIndex) + 1,
                    NextPhaseTitle: phases[currentPhaseIndex].Title
                }
                : undefined;
        };

        function submitPhase(phases, currentPhaseIndex, onUploadsComplete) {
            uploadFiles();

            var submit = $interval(function () {
                if (fileUploadsService.fileUploads.filter(function (item) { return item.Status !== 'completed'}).length > 0) {
                }
                else {
                    phases[currentPhaseIndex - 1].Status = 'Submitted';
                    onUploadsComplete();
                    $interval.cancel(submit);
                }
            }, 250);
        };

        function updatePhase(onUploadsComplete) {
            uploadFiles();

            var update = $interval(function () {
                if (fileUploadsService.fileUploads.filter(function (item) { return item.Status !== 'completed'}).length > 0) {
                } else {
                    onUploadsComplete();
                    notifyService.notify("Your changes have been saved", false);
                    $interval.cancel(update);
                }
            }, 250);
        };

        function skipPhase(phasesContainer, phases, currentPhaseIndex) {
            phases[currentPhaseIndex - 1].Status = 'Skipped';
            phasesContainer.CurrentPhaseIndex = Math.min(currentPhaseIndex, phases.length - 1);
        };

        function advancePhase(phasesContainer, phases, currentPhaseIndex, onAdvanceComplete) {
            phasesContainer.CurrentPhaseIndex = Math.min(currentPhaseIndex, phases.length - 1);
            onAdvanceComplete();
        };

        function unskipPhase(phasesContainer, phases, currentPhaseIndex, onUnskipComplete) {
            phases[currentPhaseIndex - 1].Status = 'Pending';
            phasesContainer.CurrentPhaseIndex = Math.max(currentPhaseIndex - 1, 0);
            onUnskipComplete();
            notifyService.notify("The phase has been marked as pending");
        };

        return {
            getNextPhaseSummary: getNextPhaseSummary,
            submitPhase: submitPhase,
            updatePhase: updatePhase,
            skipPhase: skipPhase,
            advancePhase: advancePhase,
            unskipPhase: unskipPhase,
            mode: mode
        };
    }

    workflowProcessingService.$inject = ['$interval', '$window', '$log', 'fileUploadsService', 'notifyService'];

    angular.module('ecap.workflow').factory('workflowProcessingService', workflowProcessingService);
})();
